
import SETTINGS from 'settings'
import { make_space } from 'network/dull_server'
import { TYPE } from 'network/server_tool'
import { random_int } from 'utils'
import { REQUEST_TYPE } from 'network/net'

/*
    [
        {
            math : {
                bonus1Wins : [],
            },
            type_id : TYPE.BONUS_1,
            win : 0,
        },
        {
            math : {
                bonus1Wins : [ 0 ],
            },
            type_id : TYPE.BONUS_1,
            win : 0,
        },
        {
            math : {
                featureType : 4,
                featureWin : 0,
                symbols : [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
            },
            type_id : TYPE.FINISH,
            win : 0,
        },
    ]
*/

export default function dull_bonus()
{
    const space = make_space()
    SETTINGS.dull_server_space = space
    
    let bonus1Wins = []
    let type_id = TYPE.BONUS_1
    let win = 0
    let open_win = 0
    let credits = 1000
    let way_map = [ TYPE.BONUS_1 ]
    
    const $spec = space.s( 'spec_login' ).alter()
    space.s( 'spec_login' )
        .map( () => ({"id":3,"code_name":"SwampLand","name":"SwampLand","lines_array":[1,3,5,7,9],"bets_array":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,50,100],"specification":{"linesAdjustment":["winShapes"],"linesCountMax":9,"linesPaths":[[1,1,1,1,1],[0,0,0,0,0],[2,2,2,2,2],[0,1,2,1,0],[2,1,0,1,2],[0,0,1,0,0],[2,2,1,2,2],[1,2,2,2,1],[1,0,0,0,1]],"priceList":[[0,0,0,2,5,20],[0,0,0,100,250,2500],[0,0,0,0,0,0],[0,0,0,5,10,50],[0,0,0,20,100,250],[0,0,0,100,1000,10000],[0,0,0,10,50,75],[0,0,0,10,50,100],[0,0,0,20,50,150]],"scatterWinCoeffs":[0,0,0,0,0,0],"substitutableElements":[0,3,4,6,7,8],"symbolBonus":2,"symbolScatter":-1,"symbolWild":1,"symbolsCount":9,"wildLineWinMultiplier":1,"winShapes":[[1,1,1,1,1],[1,1,1,1,0],[0,1,1,1,1],[1,1,1,0,0],[0,1,1,1,0],[0,0,1,1,1]]},"stage_type_map":{"1":"MAIN","2":"FINAL","4":"BONUS_1","5":"BONUS_2","7":"FEATURE_END","8":"JACKPOT","9":"PRECURSOR"},"risks":[{"type_id":2,"specification":{"nominals":["A","2","3","4","5","6","7","8","9","10","J","Q","K"],"riskId":2,"suitNames":["hearts","diamonds","spades","clubs"]},"stage_type_map":{"10":"RISK_MAIN","11":"RISK_RESULT"}}]})
        )
        .to( $spec )
    
    let scenarioData
    
    const $state = space.s( 'state_login' ).alter()
    space.s( 'state_login' )
        .map( s => Object.assign( s, {
            stage : {
                math : {
                    bonus1Wins,
                },
                type_id,
                win,
            },
            open_win,
            way_map,
        }) )
        .to( $state )
    space.s( 'net' ).on( s => console.log( 'NET:', s ) )
    
    space.s( 'request' )
        .name( space, 'stage_request' )
        .filter( request => request.type == REQUEST_TYPE.PROCEED_BONUS )
        .do( request => {
            scenarioData = scenarioData || []
            scenarioData.push( request.choice )
            
            /*if ( Math.random() < 0.85 ) win = 10 + 10 * random_int( 1, 5 ) + random_int( 1, 5 )
            else win = 0*/
            win = bonus1Wins.length * 10 + 10
            open_win += win
            bonus1Wins.push( win )
            
            way_map = [
                bonus1Wins.length >= 4
                ?
                (
                    win > 0
                    ?
                    TYPE.BONUS_2
                    :
                    TYPE.FINISH
                )
                :
                (
                    win > 0
                    ?
                    TYPE.BONUS_1
                    :
                    TYPE.FINISH
                )
            ]
        } )
        .delay( 1 )
        .with( space.s( 'handle_lobby' ), ( _, net ) => {
            net.server.scenarioData = scenarioData
            return net.server
        } )
        .to( space.s( 'login' ) )
    
    const $balance = space.s( 'balance_login' ).alter()
    space.s( 'balance_login' )
        .do( b => b.gameable = credits )
        .to( $balance )
    
    //restart the game at an attempt to continue to FINISH state:
    space.s( 'stage_request' )
        .filter( request => request.type == REQUEST_TYPE.PROCEED )
        .with( space.s( 'handle_lobby' ), ( _, net ) => net.server )
        .do( server => {
            setTimeout(
                () => {
                    scenarioData = undefined
                    server.scenarioData = scenarioData
                    
                    space.s( 'state' ).next( space.s( 'state' ).value )
                    space.s( 'init' ).next()
                    space.s( 'login' ).next()
                },
                1
            )
        } )
}











// WEBPACK FOOTER //
// ./src/dull_bonus.es6